import { S } from './Spinner.styles';
import type { SpinnerProps } from './Spinner.types';

export const Spinner = ({ size, ...otherProps }: SpinnerProps) => (
  <div aria-hidden="true" data-cy="LoadingAnimation" {...otherProps}>
    <S.SpinnerIcon size={size} />
  </div>
);
